import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { yellowBaseColor } from '../../../../constants/theme-colors';
import NxtTopBar from '../../../basic/nxt-top-bar';
import Grid from '@material-ui/core/Grid';
import { IconButton } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import IxTitle from '../../../basic/ix-title';
import IxSnackbar from '../../../basic/ix-snackbar';
import RegistrationForm from './registration-form';
import { takeoutRegistration, takeoutEditProfile } from '../../../business/home/appStateSlice';

const useStyles = makeStyles(theme => ({
  thisRoot: {
    textAlign: 'left'
    //width: '100%'
  },
  header: {
    borderBottom: '1px solid ' + theme.palette.border.guestBorder,
    backgroundColor: yellowBaseColor
    //width: '100%'
  },
  headerLeftChild: {
    color: theme.palette.text.guestNameText,
    fontSize: theme.typography.guestConfig.fontSize,
    marginLeft: '0.5em',
    marginBottom: '0.8em',
    marginTop: '1em'
  },
  headerRightChild: {
    paddingLeft: '1.5em',
    marginBottom: '0.8em',
    marginTop: '1em'
  },
  topbarText: {
    fontWeight: '600 !important',
    marginTop: '0.4em',
    fontSize: '1.3rem'
  }
}));

const TakeoutCustomerRegistration = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [error, setError] = useState(null);
  const loggedInUser =  useSelector((state) => state.appState.registeredUser.data);
  const cartItems = useSelector(state => state.cart.items);

  const handleCustomerRegistration = async values => {
    if (values.password !== values.confirmPassword) {
      setError('password mismatched');
    } else {
      dispatch(takeoutRegistration({ ...values, history }, cartItems));
    }
  };

  const handleEditProfile = async values => {
      dispatch(takeoutEditProfile({...values, history }, loggedInUser?.id));
  };

  return (
    <div className={classes.thisRoot}>
      <NxtTopBar children={loggedInUser ? t('editProfile') : t('Register')} />
      <RegistrationForm onSubmit={!loggedInUser ? handleCustomerRegistration : handleEditProfile} />
      {error && (
        <IxSnackbar
          errorMessage={error}
          handleSnackbarClose={() => setError(null)}
        />
      )}
    </div>
  );
};

export default TakeoutCustomerRegistration;
